
export default function PrivacyPage() {
  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="bg-white shadow-sm sticky top-0 z-50">
        <div className="max-w-md mx-auto px-4 py-3 flex items-center gap-2">
          <a href="/" className="flex items-center gap-2 cursor-pointer">
            <div className="w-8 h-8 flex items-center justify-center rounded-full bg-rose-500">
              <i className="ri-heart-pulse-fill text-white text-lg"></i>
            </div>
            <span className="font-bold text-lg text-gray-800" style={{ fontFamily: 'Pacifico, cursive' }}>
              LoveNavi
            </span>
          </a>
        </div>
      </header>

      <main className="max-w-md mx-auto px-4 py-8">
        <h1 className="text-xl font-bold text-gray-800 mb-6">プライバシーポリシー</h1>
        <p className="text-xs text-gray-400 mb-6">最終更新日：2025年1月1日</p>

        <div className="space-y-6 text-sm text-gray-600 leading-relaxed">
          <section>
            <h2 className="text-base font-bold text-gray-800 mb-2">1. 個人情報の収集について</h2>
            <p>当サイト（LoveNavi）では、お問い合わせやサービスのご利用に際して、お名前、メールアドレス、年齢等の個人情報をご提供いただく場合がございます。これらの情報は、サービスの提供および改善のために使用いたします。</p>
          </section>

          <section>
            <h2 className="text-base font-bold text-gray-800 mb-2">2. 個人情報の利用目的</h2>
            <p>収集した個人情報は、以下の目的で利用いたします。</p>
            <ul className="list-disc pl-5 mt-2 space-y-1">
              <li>サービスの提供・運営</li>
              <li>お問い合わせへの対応</li>
              <li>サービスの改善・新サービスの開発</li>
              <li>利用規約に違反する行為への対応</li>
              <li>メンテナンス・重要なお知らせの通知</li>
            </ul>
          </section>

          <section>
            <h2 className="text-base font-bold text-gray-800 mb-2">3. 個人情報の第三者提供</h2>
            <p>当サイトは、以下の場合を除き、ユーザーの個人情報を第三者に提供することはありません。</p>
            <ul className="list-disc pl-5 mt-2 space-y-1">
              <li>ユーザーの同意がある場合</li>
              <li>法令に基づく場合</li>
              <li>人の生命・身体・財産の保護に必要な場合</li>
              <li>公衆衛生の向上または児童の健全な育成の推進に必要な場合</li>
            </ul>
          </section>

          <section>
            <h2 className="text-base font-bold text-gray-800 mb-2">4. Cookieの使用について</h2>
            <p>当サイトでは、ユーザー体験の向上やアクセス解析のためにCookieを使用しています。ブラウザの設定によりCookieを無効にすることも可能ですが、一部のサービスが正常に機能しなくなる場合があります。</p>
          </section>

          <section>
            <h2 className="text-base font-bold text-gray-800 mb-2">5. アクセス解析ツールについて</h2>
            <p>当サイトでは、Googleアナリティクス等のアクセス解析ツールを使用する場合があります。これらのツールはトラフィックデータの収集のためにCookieを使用しています。このデータは匿名で収集されており、個人を特定するものではありません。</p>
          </section>

          <section>
            <h2 className="text-base font-bold text-gray-800 mb-2">6. 個人情報の安全管理</h2>
            <p>当サイトは、個人情報の漏洩、滅失、毀損の防止その他の安全管理のために必要かつ適切な措置を講じます。</p>
          </section>

          <section>
            <h2 className="text-base font-bold text-gray-800 mb-2">7. プライバシーポリシーの変更</h2>
            <p>当サイトは、必要に応じて本ポリシーを変更することがあります。変更後のプライバシーポリシーは、当サイトに掲載した時点から効力を生じるものとします。</p>
          </section>
        </div>
      </main>

      <footer className="bg-rose-50 py-6 px-4 mt-8">
        <div className="max-w-md mx-auto">
          <div className="flex flex-wrap justify-center gap-x-4 gap-y-2 text-xs text-gray-400 mb-3">
            <a href="/privacy" className="hover:text-rose-500 transition-colors cursor-pointer">
              プライバシーポリシー
            </a>
            <a href="/terms" className="hover:text-rose-500 transition-colors cursor-pointer">
              利用規約
            </a>
            <a href="/company" className="hover:text-rose-500 transition-colors cursor-pointer">
              運営会社
            </a>
          </div>
          <div className="text-center text-[10px] text-gray-400">
            <p>&copy; 2025 LoveNavi All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  );
}
